module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia2_thumb-6621edfaa906356564bd23b4e4c3aabf.jpg";